import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OrdenAddEditComponent } from '../orden-add-edit/orden-add-edit.component';
import { ProduccionService } from 'app/services/produccion.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { StatusChangeModalComponent } from './status-modal/status-change-modal.component';
import { ProductionStatus } from 'app/models/produccion-estado.models';
import Swal from 'sweetalert2';
import { RecetaEditCreateComponent } from '../recetas/receta-edit-create/receta-edit-create.component';
import { RecetaService } from 'app/services/receta.service';
import { UmedidaService } from 'app/services/umedida.service';
import { MeasurementUnit } from 'app/models/umedida.models';
import { Recipes } from 'app/models/receta.models';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ordenes-list',
  templateUrl: './ordenes-list.component.html',
  styleUrls: ['./ordenes-list.component.css'],
})
export class OrdenesListComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ordenes = [];
  dataSource: MatTableDataSource<any>;
  isLoading: boolean = false; // Variable para controlar el estado de carga
  unidades: MeasurementUnit[] = [];
  recetaBuscada: Recipes;

  constructor(
    private dialog: MatDialog,
    private ordenService: ProduccionService,
    private recetaService: RecetaService,
    private unidadService: UmedidaService,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource(this.ordenes); // Inicializa la fuente de datos de la tabla
  }

  ngOnInit() {
    this.getOrdenes();
    this.getUnidades();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator; // Asigna el paginador a la fuente de datos
    this.dataSource.sort = this.sort; // Asigna el ordenamiento a la fuente de datos
  }

  getOrdenes() {
    this.isLoading = true; // Cambia el estado de carga a verdadero
    this.ordenes = []; // Inicializa la lista de órdenes
    this.ordenService.getProducciones().subscribe(
      (data: any) => {
        this.ordenes = data; // Asigna los datos recibidos a la variable ordenes
        this.dataSource = new MatTableDataSource(this.ordenes); // Actualiza la fuente de datos de la tabla
        this.dataSource.paginator = this.paginator; // Asigna el paginador a la fuente de datos
        this.dataSource.sort = this.sort; // Asigna el ordenamiento a la fuente de datos
        this.isLoading = false; // Cambia el estado de carga a falso
      },
      (error: any) => {
        console.error('Error al obtener órdenes:', error);
        this.isLoading = false; // Cambia el estado de carga a falso
      }
    );
  }

  editarOrden(orden: any) {
    // Implementar la lógica para abrir el diálogo de edición
    this.ordenService.getProduccionStatus().subscribe(
      (statusList: ProductionStatus[]) => {
        const availableStatuses = this.getAvailableStatuses(
          orden.productionStatus.name,
          statusList
        );
        this.dialog
          .open(OrdenAddEditComponent, {
            width: '40%',
            data: {
              production: orden,
              availableStatuses,
            }, // Pasar la orden seleccionada al diálogo
          })
          .afterClosed()
          .subscribe(result => {
            this.getOrdenes(); // Actualizar la lista de órdenes después de editar
          });
      },
      error => {
        console.log({ error });
      }
    );
  }

  eliminarOrden(orden: any) {
    // Mostrar alerta de confirmación antes de eliminar
    Swal.fire({
      title: '¿Eliminar la orden de producción #10?',
      text: 'Esta acción revertirá el consumo de insumos y restaurará las cantidades en el stock. No se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      reverseButtons: true,
    }).then(result => {
      if (result.isConfirmed) {
        this.ordenService.deleteProduccion(orden.id).subscribe(
          () => {
            console.log('Orden eliminada correctamente');
            this.getOrdenes(); // Actualizar la lista de órdenes después de eliminar
          },
          (error: any) => {
            console.error('Error al eliminar la orden:', error);
          }
        );
      }
    });
  }

  abrirDialogo() {
    // Implementar la lógica para abrir el diálogo de edición
    this.dialog
      .open(OrdenAddEditComponent, {
        width: '40%',
        disableClose: true,
        data: {
          /* Aquí puedes pasar datos al diálogo si es necesario */
        },
      })
      .afterClosed()
      .subscribe(result => {
        this.getOrdenes(); // Actualizar la lista de órdenes después de agregar
      });
  }

  aplicarFiltro(value: string) {
    if (value) {
      this.dataSource.filter = value.trim().toLowerCase(); // Aplicar el filtro a la fuente de datos
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage(); // Volver a la primera página después de aplicar el filtro
      }
    } else {
      this.getOrdenes(); // Si no hay filtro, recargar todas las órdenes
    }
  }

  cambiarEstado(orden: any) {
    console.log({ orden });
    this.ordenService.getProduccionStatus().subscribe(
      (statusList: ProductionStatus[]) => {
        const availableStatuses = this.getAvailableStatuses(
          orden.productionStatus.name,
          statusList
        );
        console.log({ availableStatuses });
        const dialogRef = this.dialog.open(StatusChangeModalComponent, {
          width: '400px',
          height: 'auto',
          panelClass: 'custom-modal',
          data: {
            currentStatus: orden.productionStatus.name,
            availableStatuses: availableStatuses,
            ordenId: orden.id,
            quantity: orden.quantity,
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.getOrdenes();
            console.log('Estado cambiado exitosamente');
            if (result?.suitableQuantity) {
              this.ordenService
                .updateProduccion(orden.id, {
                  quantityProducedMarketable: result.suitableQuantity,
                })
                .subscribe({
                  next: () => {
                    console.log('Unidades cargadas exitosamente');
                    this.snackBar.open(
                      'Estado actualizado exitosamente.',
                      'Cerrar',
                      { duration: 3000 }
                    );
                  },
                  error: error => {
                    console.warn({ error });
                    this.snackBar.open(error.message, 'Cerrar', { duration: 3000 });
                  },
                });
            }
          }
        });
      },
      (error: any) => {
        console.error('Error al obtener estados de producción:', error);
      }
    );
  }

  private getAvailableStatuses(
    currentStatusName: string,
    statusList: ProductionStatus[]
  ): any[] {
    const statusMap: { [key: string]: string[] } = {
      Pendiente: ['En proceso', 'En espera', 'Cancelada'],
      'En proceso': ['En espera', 'Cancelada', 'Finalizada'],
      'En espera': ['En proceso', 'Cancelada', 'Finalizada'],
      Cancelada: ['En espera', 'En proceso', 'Finalizada'],
      Finalizada: ['En control de calidad'],
      'En control de calidad': ['Desechada', 'Listo para comercializar'],
      'Listo para comercializar': ['Desechada', 'En control de calidad'],
    };

    const allowedStatusNames = statusMap[currentStatusName] || [];

    return statusList
      .filter(status => allowedStatusNames.includes(status.name))
      .map(status => ({
        id: status.id,
        name: status.name,
      }));
  }

  verReceta(orden) {
    //orden.recipeId
    this.recetaService.getRecetas().subscribe({
      next: res => {
        let receta = res.find(e => e.id === orden.recipeId);
        const dialogRef = this.dialog.open(RecetaEditCreateComponent, {
          width: '60%',
          disableClose: true,
          data: {
            receta,
            unidades: this.unidades,
            onlyReadRecipe: true,
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            console.log({ result });
          }
        });
      },
      error: err => {
        console.log({ err });
      },
    });
  }

  getUnidades() {
    this.unidadService.getUmedidas().subscribe(
      (data: MeasurementUnit[]) => {
        this.unidades = data;
      },
      error => {
        console.error(error);
      }
    );
  }
}
